import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { computed } from 'vue';
import { ProductAttributes } from '~/types/ProductEnums';
export function useSearchFacets() {
  var route = useRoute();
  var router = useRouter();
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var facets = computed(function () {
    var query = route.query;
    var facets = Object.keys(query).reduce(function (acc, key) {
      try {
        if (Array.isArray(query[key]) && query[key].length) {
          acc[key] = query[key].map(function (value) {
            return decodeURIComponent(value);
          });
        } else if (!Array.isArray(query[key])) {
          acc[key] = [decodeURIComponent(query[key])];
        }
      } catch (_unused) {
        // Ignore errors in decoding query parameters
        // This can happen if the query parameter is not a valid URI component
        // and we don't want to crash the app
      }
      return acc;
    }, {});
    return facets;
  });
  function updateSearchFacets(_x) {
    return _updateSearchFacets.apply(this, arguments);
  }
  function _updateSearchFacets() {
    _updateSearchFacets = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(facets) {
      var oldQuery, query;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // A shallow copy of route.query is required here to update the route using `router.push`.
            oldQuery = Object.assign({}, route.query);
            query = Object.assign(oldQuery, facets);
            delete query.page;
            _context.next = 5;
            return router.push({
              query: query
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateSearchFacets.apply(this, arguments);
  }
  function addSearchFacet(_x2, _x3) {
    return _addSearchFacet.apply(this, arguments);
  }
  function _addSearchFacet() {
    _addSearchFacet = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(facet, value) {
      var query, filter, encodedValue;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // A shallow copy of route.query is required here to update the route using `router.push`.
            query = Object.assign({}, route.query);
            filter = query[facet];
            encodedValue = encodeURIComponent(value);
            if (Array.isArray(filter) && !filter.includes(encodedValue)) {
              query[facet] = [].concat(_toConsumableArray(query[facet]), [encodedValue]);
            } else if (filter) {
              query[facet] = [query[facet], encodedValue];
            } else {
              query[facet] = encodedValue;
            }
            delete query.page;
            _context2.next = 7;
            return router.push({
              query: query
            });
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _addSearchFacet.apply(this, arguments);
  }
  function removeSearchFacet(_x4, _x5) {
    return _removeSearchFacet.apply(this, arguments);
  }
  function _removeSearchFacet() {
    _removeSearchFacet = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(facet, removedValue) {
      var query;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // A shallow copy of route.query is required here to update the route using `router.push`.
            query = Object.assign({}, route.query);
            if (Array.isArray(query[facet])) {
              query[facet] = query[facet].filter(function (value) {
                return value !== encodeURIComponent(removedValue);
              });
            } else {
              delete query[facet];
            }
            delete query.page;
            _context3.next = 5;
            return router.push({
              query: query
            });
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _removeSearchFacet.apply(this, arguments);
  }
  function clearSearchFacets(newFacets) {
    router.push({
      query: newFacets !== null && newFacets !== void 0 ? newFacets : {}
    });
  }
  return {
    facets: facets,
    addSearchFacet: addSearchFacet,
    removeSearchFacet: removeSearchFacet,
    updateSearchFacets: updateSearchFacets,
    clearSearchFacets: clearSearchFacets
  };
}